<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div style="padding-bottom:30px!important  ">
        <div class="row">
          <div class="flex md6 sm6 xs12">
            <h4 style="font-size:24px!important" >
              Query Details &nbsp;
              <span v-if="data.status =='read' || data.status =='unread' ">
                <button @click="reply" v-scroll-to="{ element: '#reply', duration: 2000 }" type="button" class="btn btn-light pl-2" style>
                  <i class="fa fa-reply"></i>&nbsp;Reply
                </button>
              </span>
              <span v-else-if="data.status =='replied' ">
                <button @click="replied" v-scroll-to="{ element: '#view', duration: 2000 }" type="button" class="btn btn-light pl-2" style>
                  <i class="fa fa-reply"></i>&nbsp;View Reply
                </button>
              </span>
            </h4>
          </div>
        </div>
        <h6 class="pt-2 pb-2" style="background-color:#F4F3EF;"> <span class="pl-4">From:&nbsp;{{data.email}}</span></h6>
        <div class="flex md12 sm6 xs12 pl-4">
          <!-- <h5> Subject: <span style="font-size:16pz!important;font-weight:normal!important" > Problem in accessing accounts</span> </h5>    -->

          <p>Hello admin,</p>
          <p>{{data.message}}</p>
          <p>
            Thanks,
            <br />
            <span>{{data.name}}</span>
          </p>
        </div>
      </div>
      <div v-if="data.status =='replied'" class="flex md12 sm6 xs12">
        <h5 class="text-center">Admin has already responded to this Query !!</h5>
      </div>
      <div v-if="show" class="flex md10 sm6 xs12">
        <div class="row">
          <div class="flex md6 sm6 xs12"></div>
        </div>
        <b-form id="reply" @submit="onSubmit">
          <b-row class="mt-2 pl-4">
            <b-col sm="12">
              <b-form-textarea
                v-model="replyMsg"
                id="textarea-rows"
                rows="3"
                max-rows="20"
                required
                placeholder="Please enter the reply..."
              ></b-form-textarea>
            </b-col>
            <b-col sm="1"></b-col>
          </b-row>
          <div class="flex md12 sm6 xs12 pt-4 pb-4" align="right">
            <b-button type="submit" variant="success">Submit</b-button>
          </div>
        </b-form>
      </div>
      <div v-if="show1" class="flex md12 sm6 xs12">
        <div class="row">
          <div id="view" style="font-size:24px" class="flex md6 sm6 xs12">Query Reply</div>
        </div>
       <h6 class="text-justify">{{data.reply}}</h6>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  props: ['id'],
  data () {
    return {
      visible: false,
      data: [],
      remark: '',
      show: false,
      show1: false,
      replyMsg: '',
      msg: '',
      status: '',
    }
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    reply () {
      this.show = true
    },
    replied () {
      this.show1 = true
    },
    getList () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/contactadmin/view/details/' + this.id,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then(response => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.data = response.data.data
            this.status = response.data.data.status
            var dt = this.data.create_date
            dt = new Date(dt)
            dt = dt.toString()
            dt = dt.slice(0, 15)
            this.data.create_date = dt
          } else {
          }
          this.visible = false
        })
        .catch(e => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
    onSubmit (evt) {
      this.visible = true
      var data = {}
      data['id'] = this.id
      data['replyMsg'] = this.replyMsg
      console.log(this.data)
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/contactadmin/reply',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then(response => {
          this.msg = response.data.msg
          this.visible = 'false'
          this.$dlg.alert(
            this.msg,
            () => {
              this.$router.push('/listqueries')
            },
            { messageType: 'success' }
          )
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
<style scoped>
/* .modal-footer {
  display: none !important;
} */
</style>
